import * as React from 'react';
import { useStyles, FormControlProvider } from '@sravni/react-utils';
import modules_3ebc0b30 from '../styles/FormControl.module.less.js';

/**
 * @description The FormControl component is a utility component to help compose form fields
 *
 * @component
 * @example
 * ```jsx
 * <FormControl>content</FormControl>
 * ```
 */
const FormControl = React.forwardRef((props, ref) => {
    const { invalid = false, disabled = false, className, children, ...restProps } = props;
    const cx = useStyles(modules_3ebc0b30);
    const classNames = cx(className, 'container');
    const formControlContext = React.useMemo(() => ({ invalid, disabled }), [invalid, disabled]);
    return (React.createElement("div", { ref: ref, "data-qa": "FormControl", className: classNames, ...restProps },
        React.createElement(FormControlProvider, { value: formControlContext }, children)));
});
FormControl.defaultProps = {};
FormControl.displayName = 'FormControl';

export { FormControl };
//# sourceMappingURL=FormControl.js.map
